import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, MapPin, Phone, Mail, Star } from 'lucide-react';

const Footer = () => {
  const contactEmail = 'inarchdesignstudiovashi@gmail.com';

  return (
    <footer className="bg-[#2C2C2C] text-white py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          <div>
            <Link to="/" className="flex flex-col items-start mb-4">
              <span className="font-logo text-2xl font-bold text-white">
                <span className="text-[#B87333]">I</span>DS
              </span>
              <span className="font-logo text-[10px] tracking-wider text-white/80" style={{ marginTop: '-2px' }}>
                <span className="text-[#B87333]">Inarch</span> Design Studio
              </span>
            </Link>
            <p className="text-white/60 text-sm leading-relaxed mb-6">
              Creating inspiring spaces that transform the way you live and work. Premium interior design services across Maharashtra.
            </p>
            <div className="flex gap-4">
              <a href="https://www.instagram.com/inarch_design_studio_belapur/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#B87333] transition-colors">
                <Instagram size={18} />
              </a>
              <a href="https://www.facebook.com/people/Inarch-Design-Studio/61557602909730/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#B87333] transition-colors">
                <Facebook size={18} />
              </a>
              <a href="https://www.google.com/search?q=inarchdesignstudio" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#B87333] transition-colors">
                <Star size={18} />
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-medium mb-4 text-lg">Quick Links</h4>
            <ul className="space-y-3">
              {[
                { path: '/', label: 'Home' },
                { path: '/about', label: 'About Us' },
                { path: '/services', label: 'Services' },
                { path: '/gallery', label: 'Gallery' },
                { path: '/contact', label: 'Contact' },
              ].map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className="text-white/60 hover:text-[#B87333] text-sm transition-colors"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-medium mb-4 text-lg">Our Services</h4>
            <ul className="space-y-3 text-white/60 text-sm">
              <li><Link to="/services" className="hover:text-[#B87333] transition-colors">Residential Interiors</Link></li>
              <li><Link to="/services" className="hover:text-[#B87333] transition-colors">Commercial Spaces</Link></li>
              <li><Link to="/services" className="hover:text-[#B87333] transition-colors">Luxury Villas</Link></li>
              <li><Link to="/services" className="hover:text-[#B87333] transition-colors">Modular Kitchen</Link></li>
              <li><Link to="/services" className="hover:text-[#B87333] transition-colors">Landscape Design</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-medium mb-4 text-lg">Contact Info</h4>
            <ul className="space-y-4 text-white/60 text-sm">
              <li className="flex items-start gap-3">
                <MapPin size={18} className="text-[#B87333] mt-0.5 flex-shrink-0" />
                <span>Office no. 220, Skylark, Plot no. 63, Shahbaz Village, Sector 11, CBD Belapur, Navi Mumbai, Maharashtra – 400614</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={18} className="text-[#B87333] flex-shrink-0" />
                <div className="flex flex-col">
                  <a href="tel:+918591613610" className="hover:text-[#B87333]">+91 8591613610</a>
                  <a href="tel:+919820336742" className="hover:text-[#B87333]">+91 9820336742</a>
                </div>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={18} className="text-[#B87333] flex-shrink-0" />
                <a href={`mailto:${contactEmail}`} className="hover:text-[#B87333]">{contactEmail}</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/40 text-sm">
            © 2025 InArch Design Studio. All rights reserved.
          </p>
          <div className="flex gap-6 text-white/40 text-sm">
            <a href="#" className="hover:text-white transition-colors">Privacy Policy</a>
            <a href="#" className="hover:text-white transition-colors">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
